"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Converts a given time and type into milliseconds.
 *
 * @param {number} time - The amount of time to convert.
 * @param {TimeType} type - The unit of the provided time.
 *                          Options are 'seconds', 'minutes', 'hours', 'days', or 'years'.
 * @returns {number} The equivalent time in milliseconds.
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * toMilliseconds(2, 'minutes') // Returns 120000
 */
function toMilliseconds(time, type) {
  const timeMultipliers = {
    seconds: 1000,
    minutes: 1000 * 60,
    hours: 1000 * 60 * 60,
    days: 1000 * 60 * 60 * 24,
    years: 1000 * 60 * 60 * 24 * 365
  };
  return time * timeMultipliers[type];
}
var _default = exports.default = toMilliseconds;